import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Avatar, Loading, Empty } from "../components/common";
import { Heart, MessageCircle, Repeat2, UserPlus, Coins, Bell, Radio, Trophy } from "lucide-react";
import { formatDistanceToNowStrict } from "date-fns";

const ICON = { like: Heart, comment: MessageCircle, repost: Repeat2, follow: UserPlus, tip: Coins, message: MessageCircle, live: Radio, achievement: Trophy };
const COLOR = { like: "text-rose-400", tip: "text-gold", follow: "text-eblue", live: "text-destructive", achievement: "text-gold" };

export default function Notifications() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/notifications").then(({ data }) => setItems(data));
    api.post("/notifications/read").catch(() => {});
  }, []);
  if (!items) return <Loading />;
  return (
    <div className="px-4 md:px-6 py-5 max-w-2xl">
      <div className="flex items-center gap-2 mb-5"><Bell className="text-eblue" /><h1 className="font-display font-bold text-2xl">Notifications</h1></div>
      {items.length === 0 ? <Empty icon={Bell} title="All caught up" hint="New followers, likes, tips and chart moves show up here." /> : (
        <div className="surface rounded-2xl divide-y divide-white/5">
          {items.map((n) => { const Icon = ICON[n.type] || Bell; return (
            <Link key={n.id} to={n.link || "#"} className={`flex items-center gap-3 p-4 hover:bg-white/5 transition-colors ${!n.read ? "bg-eblue/5" : ""}`} data-testid={`notif-${n.id}`}>
              {n.actor ? <Avatar src={n.actor.avatar_url} name={n.actor.display_name} size={40} /> : <div className="w-10 h-10 rounded-full surface-2 flex items-center justify-center"><Icon size={18} /></div>}
              <div className="flex-1 min-w-0"><p className="text-sm">{n.text}</p><div className="text-xs text-muted-foreground">{(() => { try { return formatDistanceToNowStrict(new Date(n.created_at)) + " ago"; } catch { return ""; } })()}</div></div>
              <Icon size={16} className={COLOR[n.type] || "text-muted-foreground"} />
            </Link>
          ); })}
        </div>
      )}
    </div>
  );
}
